export enum EnvironmentEnum {
  PRODUCTION = 'production',
  INTEGRATION = 'integration',
  LOCALHOST = 'localhost',
}
